
export class GetUnreadNotificationCountsForDanceManagersRequestDto {
  danceManagerIds: string[];
}
